module.exports = __webpack_public_path__ + "static/media/custom-bg-5.4b59b28a.png";